import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { DocumentService } from 'src/app/services/document/document.service';

@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.scss']
})
export class AddDocumentComponent {
  public usefulDocForm!: FormGroup;
  public isAddDocForm: boolean = false;
  constructor(private fb: FormBuilder, private appService: AppService, public dialogRef: MatDialogRef<AddDocumentComponent>, private docService: DocumentService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.usefulDocForm = this.fb.group({
      'd_n': ['', Validators.required],
      'd_desc': [''],
      'v_u': [''],
      'e_u': [''],
      'd_tp': ['0', Validators.required],
      's_edt': [true],
      'dt': ['', Validators.required],
      'n_u': []
    })
    if (this.dialogData && (this.dialogData.isDocFromDashboard == true)) {
      this.isAddDocForm = true
    }
    // Define the subscription function
    const valueChangesSubscription = this.usefulDocForm.get('s_edt')?.valueChanges.subscribe(val => {
      // Your code here
      this.usefulDocForm.get('s_edt')?.valueChanges.subscribe(val => {
        if (val === true) {
          this.usefulDocForm.controls['dt'].setValidators([Validators.required]);
        }
        else {
          this.usefulDocForm.controls['dt'].clearValidators();
        }
        this.usefulDocForm.controls['dt'].updateValueAndValidity();
      })
    });

    // // Programmatically set the value
    // this.usefulDocForm.get('s_edt').setValue(newValue); // Replace newValue with the value you want to set

    // // Ensure validation runs if needed
    // this.usefulDocForm.get('s_edt').updateValueAndValidity();

    // // Manually trigger the subscription code
    // valueChangesSubscription.unsubscribe(); // Unsubscribe to avoid multiple executions
    // valueChangesSubscription.subscribe(); // Re-subscribe to trigger the code

    if (this.dialogData) {
      for (let [key, value] of Object.entries(this.usefulDocForm.value)) {
        for (let [fkey, fval] of Object.entries(this.dialogData)) {
          if (key == fkey) {

            this.usefulDocForm.get(key)?.setValue(fval)
            if (key == 'd_tp') {
              this.usefulDocForm.get(key)?.setValue(JSON.stringify(fval))
            }
          }
          if (key == 's_edt') {
            if (key == 's_edt' && fval == 0) {
              this.usefulDocForm.get(key)?.setValue(false)
            }
            if (key == 's_edt' && fval == 1) {
              this.usefulDocForm.get(key)?.setValue(true)
            }
            this.usefulDocForm.get('dt')?.updateValueAndValidity();
            //   valueChangesSubscription?.unsubscribe(); // Unsubscribe to avoid multiple executions
            //  valueChangesSubscription.subscribe()
          }

        }
      }
    }
    this.formValidtaion()
  }
  formValidtaion() {
    this.usefulDocForm.get('s_edt')?.valueChanges.subscribe(val => {
      if (val === true) {
        this.usefulDocForm.controls['dt'].setValidators([Validators.required]);
      }
      else {
        this.usefulDocForm.controls['dt'].clearValidators();
      }
      this.usefulDocForm.controls['dt'].updateValueAndValidity();
    })
  }
  onSubmit() {
    if (this.usefulDocForm.invalid) {
      this.usefulDocForm.markAllAsTouched()
    }
    else {

      let data: Document = this.usefulDocForm.value
      data["dt"] = this.datePipe.transform(data["dt"], 'yyyy-MM-dd');

      if (data["v_u"] == true) {
        data["v_u"] = 1
      }
      else {
        data["v_u"] = 0
      }
      if ((data["n_u"] == null) || (data["n_u"] == false)) {
        data["n_u"] = 0
      }
      else {
        data["n_u"] = 1
      }
      if (this.isAddDocForm) {

        data["pack_id"] = this.dialogData.pack_id

        // if(this.usefulDocForm.value.d_tp==0){
        this.docService.addDoc(data).subscribe((result: any) => {
          if (result.status == 200) {
            this.dialogRef.close({ data_added: true })
            if (this.usefulDocForm.value.d_tp == 1 && (result.data.url)) {
              var newWindow = window.open(result.data.url, '_blank', 'height=700,width=700');
            }
            else {
              this.appService.showToastMessage('success', result.msg)
            }
          }

        })
        // }
        // if(this.usefulDocForm.value.d_tp==1){
        //   this.docService.addContract(data).subscribe((result)=>{
        //     if(result.status==200){
        //       var newWindow = window.open(result.data.url, '_blank', 'height=700,width=700');
        //     }
        //   })
        // }
      }
      else {
        if (this.dialogData) {
          const mergedObject = Object.assign({}, this.dialogData, this.usefulDocForm.value);
          this.dialogRef.close(mergedObject)
        }
        else {
          this.dialogRef.close(this.usefulDocForm.value)
        }

      }
    }
  }
  isControlHasError(controlName: string, validation: string) {
    return this.appService.isControlHasError(this.usefulDocForm, controlName, validation)
  }
  onCancel() {
    this.dialogRef.close()
  }
}
